import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../../variables';

const Tag = ({ colour, children, className }) => {
  return <div className={className}>{children}</div>;
};

// === Tag CSS ===
const StyledTag = styled(Tag)`
  display: inline-block;
  height: 2.2rem;
  --default-background-colour: ${vars.coreDarkGrey};
  color: ${vars.white};
  background-color: ${({ colour }) =>
    colour ? colour : 'var(--default-background-colour)'};
  ${vars.fontSize1}
  font-weight: ${vars.fontWeightRegular};
  line-height: 1.24;
  padding: ${vars.spacingXs} ${vars.spacingS};
  width: fit-content;
  border-radius: 4px;
  &::first-letter {
    text-transform: uppercase;
  }
`;

export default StyledTag;
